// extracted by css-extract-rspack-plugin
export default {"backdrop":"backdrop-jpY6xZ","backdropHidden":"backdropHidden-RyStBe","panel":"panel-UxJ7s7","panelHidden":"panelHidden-DOkcCL"};